(function () {
  /* ---------- Store hours: live "Open today until 6pm" ---------- */
  function initStoreStatus() {
    var data = window.StoreHours;
    var els = document.querySelectorAll('[data-store-status]');
    if (!data) return;
    var DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var re = /(\d{1,2})(?::(\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?\s*(?:-|–|—|to)\s*(\d{1,2})(?::(\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?/i;

    function toMin(h, m, ap, isClose) {
      h = parseInt(h, 10); m = parseInt(m || '0', 10);
      if (ap) {
        var pm = /p/i.test(ap);
        if (h === 12) h = pm ? 12 : 0; else if (pm) h += 12;
      } else if (isClose ? h < 12 : h < 7) {
        h += 12;
      }
      return h * 60 + m;
    }
    function parse(str) {
      if (!str || /closed/i.test(str)) return null;
      var r = re.exec(str);
      if (!r) return null;
      return { open: toMin(r[1], r[2], r[3], false), close: toMin(r[4], r[5], r[6], true) };
    }
    function fmt(min) {
      var h = Math.floor(min / 60) % 24, m = min % 60;
      var ap = h >= 12 ? 'pm' : 'am';
      var h12 = h % 12 === 0 ? 12 : h % 12;
      return h12 + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ap;
    }
    function nowParts() {
      var d = new Date(), o = {};
      try {
        new Intl.DateTimeFormat('en-US', { timeZone: data.tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })
          .formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
        var date = new Date(Date.UTC(+o.year, +o.month - 1, +o.day));
        return { date: date, dow: date.getUTCDay(), min: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
      } catch (e) {
        return { date: new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())), dow: d.getDay(), min: d.getHours() * 60 + d.getMinutes() };
      }
    }
    var MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    function holidays(today) {
      var out = {};
      (data.holidays || '').split(/\n+/).forEach(function (line) {
        var m = /^\s*(?:([a-z]{3})[a-z]*\.?\s+(\d{1,2})|(\d{1,2})\/(\d{1,2}))(?:,?\s*(\d{4}))?\s*[:\-–]\s*(.+)$/i.exec(line);
        if (!m) return;
        var mon = m[1] ? MONTHS.indexOf(m[1].toLowerCase()) : parseInt(m[3], 10) - 1;
        var day = parseInt(m[2] || m[4], 10);
        if (mon < 0 || !day) return;
        var yr = m[5] ? +m[5] : today.getUTCFullYear();
        var dt = new Date(Date.UTC(yr, mon, day));
        if (!m[5] && dt - today < -60 * 864e5) dt = new Date(Date.UTC(yr + 1, mon, day));
        out[dt.toISOString().slice(0, 10)] = { date: dt, hours: m[6].trim() };
      });
      return out;
    }
    function hoursFor(date, hol) {
      var key = date.toISOString().slice(0, 10);
      return hol[key] ? hol[key].hours : data.days[date.getUTCDay()];
    }
    function status(n, hol) {
      if (data.notice) return { state: 'notice', text: data.notice };
      var todayKey = n.date.toISOString().slice(0, 10);
      var today = parse(hoursFor(n.date, hol));
      var special = hol[todayKey] ? 'Holiday hours · ' : '';
      if (today && n.min >= today.open && n.min < today.close) {
        var soon = today.close - n.min <= 45;
        return { state: soon ? 'soon' : 'open', text: special + (soon ? 'Closing soon · open until ' : 'Open today until ') + fmt(today.close) };
      }
      if (today && n.min < today.open) return { state: 'closed', text: special + 'Closed now · opens today at ' + fmt(today.open) };
      for (var k = 1; k <= 14; k++) {
        var d = new Date(n.date.getTime() + k * 864e5), h = parse(hoursFor(d, hol));
        if (h) return { state: 'closed', text: (hol[todayKey] && !today ? 'Closed today for the holiday · opens ' : 'Closed now · opens ') + (k === 1 ? 'tomorrow' : k < 7 ? DAY[d.getUTCDay()] : DAY[d.getUTCDay()] + ' ' + (d.getUTCMonth() + 1) + '/' + d.getUTCDate()) + ' at ' + fmt(h.open) };
      }
      return null;
    }
    function paintHolidays(n, hol) {
      var lists = document.querySelectorAll('[data-holiday-hours]');
      if (!lists.length) return;
      var soon = Object.keys(hol).map(function (k) { return hol[k]; })
        .filter(function (h) { var diff = (h.date - n.date) / 864e5; return diff >= 0 && diff <= 14; })
        .sort(function (a, b) { return a.date - b.date; });
      lists.forEach(function (box) {
        var dl = box.querySelector('dl');
        if (!soon.length || !dl) { box.hidden = true; return; }
        dl.innerHTML = '';
        soon.forEach(function (h) {
          var row = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
          dt.textContent = DAY[h.date.getUTCDay()].slice(0, 3) + ' ' + (h.date.getUTCMonth() + 1) + '/' + h.date.getUTCDate();
          dd.textContent = h.hours;
          row.appendChild(dt); row.appendChild(dd); dl.appendChild(row);
        });
        box.hidden = false;
      });
    }
    function paint() {
      var n = nowParts(), hol = holidays(n.date);
      paintHolidays(n, hol);
      var s = status(n, hol);
      if (!s) return;
      els.forEach(function (el) {
        el.setAttribute('data-state', s.state);
        var t = el.querySelector('[data-store-status-text]');
        if (t) t.textContent = s.text;
      });
    }
    paint();
    setInterval(paint, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStoreStatus);
  else initStoreStatus();
})();
